import React, { Component } from 'react';
//import {connect} from 'react-redux';

import './../../../scss/App.scss';

//import { trackingWrapper } from '../../utils/analytics';

class AnswerField extends Component {

	constructor(props){
		super(props);

		this.maxChars = 20;

		this.state = {
		}

		//

		this.handleOnChange = this.handleOnChange.bind(this);
		this.handleDelete = this.handleDelete.bind(this);

	}

	componentDidMount(){
		//console.log("-- AnswerField Mounted --");
	}

	handleOnChange(e){
		const value = e.target.value.replace(/[^a-zA-Z ]/g, "").toUpperCase()

		this.props.handleUpdateAnswer(this.props.answerObj.key, value);
	}

	handleDelete(){
		//console.log("AnswerField key:", this.props.answerObj.key);
		this.props.handleDeleteBtn(this.props.answerObj.key);
	}


	renderDeleteBtn(){
		if(this.props.showDelete){
			return(
				<div className="truncateBtn fa-solid fa-trash-can" onClick={this.handleDelete}></div>
			)
		}
	}

	render() {
		let badWordFound = "";

		if(this.props.badWordFound){
			badWordFound = "error";
		}

		return (
			<div className={"answer " + badWordFound}>
				<div className="number">{this.props.number}.</div>
				<input className="answerField" type="text" value={this.props.answerObj.value} placeholder="Answer" maxLength="20" onChange={this.handleOnChange}/>
				{this.renderDeleteBtn()}
				<div className="count">{this.props.answerObj.value.length}/{this.maxChars}</div>
			</div>
		);
	}
}

export default AnswerField;


// WEBPACK FOOTER //
// ./src/js/components/generator/AnswerField.js